import useAuth from "./useAuth";

export function usePermission() {
  const { user } = useAuth();

  const can = (permission: any): boolean =>
    user?.permissions.includes(permission) ?? false;

  const canAny = (...permissions: any[]): boolean => {
    const userPermissionSet = new Set<string>(user?.permissions || []);
    return permissions.flat().some((p) => {
      return userPermissionSet.has(p);
    });
  };

  const canAll = (...permissions: any[]): boolean =>
    permissions.every((p) => user?.permissions.includes(p));

  return { can, canAny, canAll };
}
